import type React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import Button from "~/components/ui/button";
import { CustomCheckbox } from "~/components/ui/check_Box";
import { planMap } from "~/constants/planMap";
import close from "~/images/close.svg";
import type { RootState } from "~/store";
import CancelCompleteReqxign from "../cancelCompleteReqxign";

import styles from "./index.module.scss";

interface CancelReqxignModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CancelReqxignModal: React.FC<CancelReqxignModalProps> = ({ isOpen, onClose }) => {
  const [isLock] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const organization = useSelector((state: RootState) => state.auth.organization);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleSubmit = async () => {
    // TODO: 解約処理を呼び出す
    openModal();
  };

  const handleClose = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={styles["overlay"]}>
      <div className={styles["modal"]}>
        <div className={styles["modalHeader"]}>
          <h2 className={styles["custom-h2"]}>REQXIGNを解約</h2>
          <button className={styles["closeButton"]} onClick={handleClose}>
            <img src={close} alt="閉じる" />
          </button>
        </div>

        <div className={styles["modalContent"]}>
          <section className={styles["sectionDetail"]}>
            <div className={styles["sectionDetail_title"]}>契約内容</div>
            <div className={styles["sectionDetail_content"]}>
              <div className={styles["sectionDetail_content_container"]}>
                <div className={styles["sectionDetail_content_container_label"]}>契約プラン</div>
                <div className={styles["sectionDetail_content_container_content"]}>
                  {planMap[organization?.plan?.type].name}
                </div>
              </div>
              {/* <div className={styles["sectionDetail_content_container"]}>
                <div
                  className={styles["sectionDetail_content_container_label"]}
                >
                  次回更新日
                </div>
                <div
                  className={styles["sectionDetail_content_container_content"]}
                >
                  2025年10月30日
                </div>
              </div> */}
            </div>
          </section>

          <section className={styles["sectionDetail"]}>
            <div className={styles["sectionDetail_title"]}>ご利用状況</div>
            <div className={styles["sectionDetail_content"]}>
              {/* <div className={styles["sectionDetail_content_container"]}>
                <div
                  className={styles["sectionDetail_content_container_label"]}
                >
                  プロジェクト数
                </div>
                <div
                  className={styles["sectionDetail_content_container_content"]}
                >
                  8プロジェクト
                </div>
              </div> */}
              <div className={styles["sectionDetail_content_container"]}>
                <div className={styles["sectionDetail_content_container_label"]}>
                  残りクレジット数
                </div>
                <div className={styles["sectionDetail_content_container_content"]}>
                  120クレジット
                </div>
              </div>
              {/* <div className={styles["sectionDetail_content_container"]}>
                <div
                  className={styles["sectionDetail_content_container_label"]}
                >
                  ご利用ユーザー数
                </div>
                <div
                  className={styles["sectionDetail_content_container_content"]}
                >
                  20名
                </div>
              </div> */}
            </div>
          </section>

          <section className={styles["sectionDetail"]}>
            <div className={styles["sectionDetail_title"]}>解約の注意点</div>
            <div className={styles["sectionDetail_content"]}>
              <ul>
                <li>解約後すぐにサービスの利用が停止され、残りクレジットは0になります。</li>
                <li>
                  解約すると全てのデータが削除されます。（
                  <span className={styles["sectionDetail_content_bracket"]}>
                    30日以内に再契約した場合はデータが復旧されます。
                  </span>
                  ）
                </li>
              </ul>
            </div>
          </section>

          <CustomCheckbox
            label="解約の注意点を確認した"
            checked={isConfirmed}
            onChange={(checked: boolean) => setIsConfirmed(checked)}
          />
        </div>
        <div className={styles["modalFooter"]}>
          <Button
            label="キャンセル"
            styleType="white"
            onClick={handleClose}
            heightType="itemModalType"
          />
          <Button
            label={!isLock ? "解約" : "解約中"}
            styleType={!isConfirmed ? "warning-disable" : "warning"}
            heightType="itemModalType"
            onClick={handleSubmit}
            disabled={isLock || !isConfirmed}
          />
        </div>
      </div>
      <CancelCompleteReqxign isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
};

export default CancelReqxignModal;
